import { Check } from 'lucide-react';

import styles from './VideoSelector.module.css';

interface VideoSelectorProps {
  activeVideoId: string;
  onSelect: (videoId: string) => void;
  videoIds: string[];
}

export function VideoSelector({
  activeVideoId,
  onSelect,
  videoIds,
}: VideoSelectorProps) {
  if (videoIds.length <= 1) {
    return null;
  }

  return (
    <ol aria-label="Video selection" className={styles.list}>
      {videoIds.map((videoId, index) => {
        const isActive = videoId === activeVideoId;

        return (
          <li className={styles.item} key={videoId}>
            <button
              aria-current={isActive ? 'true' : undefined}
              aria-label={`Load Video ${index + 1}`}
              className={styles.button}
              data-active={isActive}
              onClick={() => {
                onSelect(videoId);
              }}
              type="button"
            >
              {/* More than colour marks the chosen video (WCAG 1.4.1). */}
              {isActive ? <Check aria-hidden="true" size={16} strokeWidth={2.5} /> : null}
              {`Video ${index + 1}`}
            </button>
          </li>
        );
      })}
    </ol>
  );
}
